import { Components, menuItemClasses, Theme } from '@mui/material';

export function getMuiMenuItem(theme: Theme): Components['MuiMenuItem'] {
  return {
    styleOverrides: {
      root: {
        '&:hover': {
          backgroundColor: theme.palette.grey[100],
        },

        [`&.${menuItemClasses.selected}`]: {
          backgroundColor: theme.palette.background.default,
        },
      },
    },
  };
}
